import React from 'react';

import { Icon } from '@chakra-ui/react';

export const AzureSynapseAnalyticsIcon = props => (
  <Icon viewBox="0 0 720 720" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-316 0)">
      <g>
        <path
          d="M663 0 349 179.6 349 538.4 663 720 977 540.4 977 180.4ZM919 502.8 663 650.8 407 504.36 407 215.2 663 67.2 919 215.6Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
        <path
          d="M663 0 663 0 349 179.6 407 215.2 663 67.2 919 215.2 977 179.6 663 0Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
        <path
          d="M812.6 419C809.544 413.972 805.04 409.984 799.68 407.56 766.62 335.389 699.142 284.97 620.56 273.72L879.64 124 819.4 89.44 524.36 260C510 268.266 505.061 286.607 513.326 300.966 518.693 310.29 528.642 316.026 539.4 316 540.62 315.775 541.822 315.468 543 315.08L548 336C625.411 317.746 705.28 354.701 741.48 425.52L447.52 595.4 507.52 630.04 801.64 460C805.56 457.656 808.876 454.42 811.32 450.56L814.32 449.84C814.04 448.68 813.6 447.64 813.32 446.48 817.64 437.764 817.372 427.476 812.6 419Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
        <path
          d="M786.64 360.52C745.772 360.52 712.64 393.651 712.64 434.52 712.64 475.388 745.772 508.52 786.64 508.52 827.508 508.52 860.64 475.388 860.64 434.52 860.64 393.651 827.508 360.52 786.64 360.52ZM539.36 210.68C498.491 210.68 465.36 243.811 465.36 284.68 465.36 325.549 498.491 358.68 539.36 358.68 580.229 358.68 613.36 325.549 613.36 284.68 613.36 243.811 580.229 210.68 539.36 210.68Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
      </g>
    </g>
  </Icon>
);
